import { fmtBRL } from "@/lib/api";
import { Repeat } from "lucide-react";

export const ReguaCard = ({ rows }) => (
  <div data-testid="regua-card" className="rounded-2xl border border-[#1F293D] bg-[#111827] p-5 fade-up">
    <h3 className="mb-1 flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-slate-200">
      <Repeat className="h-4 w-4 text-emerald-400" /> Resultado da régua de SMS
    </h3>
    <p className="mb-4 text-xs text-slate-500">Clientes que renovaram depois de receber cada mensagem (contagem desde o início dos envios reais).</p>
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {rows.map((r) => (
        <div key={r.rule} data-testid={`regua-${r.offset_days}`} className={`rounded-xl border p-4 ${r.offset_days === 7 ? "border-emerald-500/40 bg-emerald-500/5" : "border-[#1F293D] bg-[#0F141F]"}`}>
          <div className="text-xs font-semibold text-slate-300">{r.rule}</div>
          <div className="mt-2 flex items-baseline gap-2">
            <span data-testid={`regua-renewed-${r.offset_days}`} className="font-mono text-2xl font-extrabold text-white">{r.renewed}</span>
            <span className="text-xs text-slate-500">renovaram de {r.sent} ({r.rate}%)</span>
          </div>
          <div className="mt-1 font-mono text-sm font-semibold text-emerald-300">{fmtBRL(r.revenue)}</div>
          <div className="mt-2 flex gap-3 font-mono text-[11px]">
            <span className="text-[#22C55E]">{r.delivered} entregue{r.delivered === 1 ? "" : "s"}</span>
            <span className="text-[#3B82F6]">{r.sent - r.delivered - r.failed} enviado{r.sent - r.delivered - r.failed === 1 ? "" : "s"}</span>
            <span className="text-[#EF4444]">{r.failed} falha{r.failed === 1 ? "" : "s"}</span>
          </div>
        </div>
      ))}
    </div>
  </div>
);
